import { Component, OnInit } from "@angular/core";
import { WizardStep, WizardParam, NewStep } from "./wizard.model";
import { WizardService } from "./wizard.service";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { RoutePath } from "./../shared/constants/globals.constant";
import {
  Payment,
  Transaction,
} from "../shared/models/payment-transaction.model";
import { PaymentTransactionService } from "../shared/services/payment-transaction/payment-transaction.service";
import { Subscription } from "rxjs";
import { ModalConfig } from "../shared/models/modal.model";

@Component({
  selector: "app-wizard",
  templateUrl: "./wizard.component.html",
  styleUrls: ["./wizard.component.scss"],
})
export class WizardComponent implements OnInit {
  public wizardSteps = new Array();
  public currentStep: string;
  public initialStep: number;
  public numberSteps: number;

  public displayDeleteCoupon: boolean = false;

  constructor(
    private wizardService: WizardService,
    private router: Router,
    private paymentTransactionService: PaymentTransactionService,
  ) {}

  ngOnInit() {
    this.wizardService.paramsInformation.subscribe(
      (wizardParam: WizardParam) => {
        // TODO: this number (5) must be paramter by contant or something configuable
        if (this.wizardSteps.length < 5) {
          this.initBuildWizardSteps(wizardParam);
        }
      },
    );

    this.wizardService.updateCurrentStep.subscribe((newStep: NewStep) => {
      const targetStep = this.wizardSteps[newStep.step];
      if (!targetStep) return;
      this.updateWizardState(targetStep);
      if (newStep.flow === "tokenize" && newStep.cpe) {
        this.router.navigate([
          RoutePath.tokenizeCard,
          newStep.cpe,
          "step",
          newStep.step + 1,
        ]);
      } else {
        this.router.navigate([
          this.wizardSteps[newStep.step].path,
          newStep.transaction,
        ]);
      }
    });

    this.wizardService.reloadNavigation.subscribe((stepNumber: number) => {
      this.reloadWizardCache(stepNumber);
    });

    this.wizardService.changeWizardSteps.subscribe((path: string) => {
      if (this.wizardSteps) {
        this.wizardSteps = this.wizardSteps.filter(
          (step) => step.path !== path,
        );
        this.wizardSteps.forEach((step, i) => (step.stepNumber = i));

        const currentStepIndex = this.wizardSteps.findIndex((step) => {
          return step.path === this.router.url.split("/")[1];
        });
        if (this.wizardSteps[currentStepIndex]) {
          this.setInitialWizardConfiguration(
            this.wizardSteps[currentStepIndex],
          );
        }
      }
    });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        setTimeout(() => {
          if (
            (this.paymentTransactionService.isAdminPlatform &&
              this.paymentTransactionService.firstLoad) ||
            (this.paymentTransactionService.isCvuInit &&
              this.paymentTransactionService.firstLoad)
          ) {
            sessionStorage.removeItem("wizardCache");
          }
          this.reloadWizardCache(this.getCurrentPath());
        });
      });

    this.subcriptionDeleteCoupon();

    const transaction = this.paymentTransactionService.getCacheTransaction();
    if (transaction) {
      if (transaction.payments.some((x) => x.coupon != null)) {
        this.wizardService.setExpirationDate(
          transaction.payments.find((x) => x.coupon != null).coupon
            .expirationDate,
        );
      }
    }
  }

  subcriptionDeleteCoupon() {
    this.wizardService.getDeletecouponStatus().subscribe((status) => {
      if (status) {
        this.openModalDeleteCoupon();
      }
    });
  }

  openModalDeleteCoupon() {
    this.displayDeleteCoupon = true;
  }
  public closeModalDeleteCoupon(): void {
    this.displayDeleteCoupon = false;
  }

  private getCurrentPath() {
    const segments = this.router.url.split("/").map((s) => s.split("?")[0]);
    if (segments[1] === "tokenize-card") {
      const stepSegment = segments[3];
      const stepNum = segments[4];
      if (stepSegment === "step" && stepNum) {
        return `tokenize-card-step-${stepNum}`;
      }
      if (segments[3] === "result") {
        return "tokenize-card-result";
      }
      return "tokenize-card-step-1";
    }
    if (
      this.paymentTransactionService.isCvuInit &&
      this.paymentTransactionService.firstLoad
    ) {
      return RoutePath.cvuInitPayment;
    }
    if (
      this.paymentTransactionService.isAdminPlatform &&
      this.paymentTransactionService.firstLoad
    ) {
      let pathPos = this.wizardService.currentStep;
      if (pathPos === undefined) {
        pathPos = 1;
      }
      return segments[pathPos] || segments[1];
    } else {
      return segments[1];
    }
  }

  private reloadWizardCache(currentPath): void {
    const isTokenizeCard =
      typeof currentPath === "string" &&
      (currentPath.startsWith("tokenize-card-step-") ||
        currentPath === "tokenize-card-result");
    if (isTokenizeCard) {
      sessionStorage.removeItem("wizardCache");
      this.wizardSteps =
        JSON.parse(sessionStorage.getItem("tokenizeCardWizardCache")) || [];
      const segments = this.router.url.split("/");
      const cpe = segments[2];
      if (this.wizardSteps.length === 0 && cpe) {
        this.clearWizzardSteps();
        this.addTokenizeCardSteps(cpe);
      }
    } else {
      this.wizardSteps = JSON.parse(sessionStorage.getItem("wizardCache"));
      if (this.paymentTransactionService.isCvuInit) {
        this.clearWizzardSteps();
        this.addCvuInitPaymentSteps();
      } else if (!this.wizardSteps) {
        this.wizardSteps = [];
        if (this.paymentTransactionService.isAdminPlatform) {
          this.addInitAdminPaymentStep();
        } else {
          this.addInitPaymentStep();
        }
        this.addReviewPaymentStep();
        this.addPaymentMethodStep();
        this.addConfirmPaymentStep();
        this.addConfirmedPaymentStep();
      }
    }

    const currentStepIndex = this.wizardSteps.findIndex(
      (step) => step.path === currentPath,
    );
    if (this.wizardSteps[currentStepIndex]) {
      this.setInitialWizardConfiguration(this.wizardSteps[currentStepIndex]);
    }
  }

  private initBuildWizardSteps(wizardParam) {
    this.clearWizzardSteps();
    if (this.paymentTransactionService.isCvuInit) {
      this.addCvuInitPaymentSteps();
    } else if (wizardParam.transactionId) {
      this.reloadWizardCache(RoutePath.initPayment);
    } else {
      if (this.paymentTransactionService.isAdminPlatform) {
        this.addInitAdminPaymentStep();
      } else {
        this.addInitPaymentStep();
      }
      if (!wizardParam.urlParams.email || !wizardParam.urlParams.name) {
        this.addReviewPaymentStep();
      }
      this.addPaymentMethodStep();
      this.addConfirmPaymentStep();
      this.addConfirmedPaymentStep();
    }
    if (this.wizardSteps[0]) {
      this.setInitialWizardConfiguration(this.wizardSteps[0]);
    }
  }

  private updateWizardState(currentWizardStep: WizardStep) {
    if (currentWizardStep) {
      currentWizardStep.state = "active";
      this.wizardSteps.forEach((wizardStep: WizardStep) => {
        if (wizardStep.stepNumber < currentWizardStep.stepNumber) {
          wizardStep.state = "completed";
        }
        if (wizardStep.stepNumber > currentWizardStep.stepNumber) {
          wizardStep.state = null;
        }
      });
    }
  }

  private setInitialWizardConfiguration(initWizardstep) {
    const isTokenizeCard =
      this.wizardSteps.length > 0 &&
      this.wizardSteps[0].path?.startsWith("tokenize-card-step");
    const cacheKey = isTokenizeCard ? "tokenizeCardWizardCache" : "wizardCache";
    sessionStorage.setItem(cacheKey, JSON.stringify(this.wizardSteps));
    this.wizardService.setInitialStep(initWizardstep, this.wizardSteps);
    this.updateWizardState(initWizardstep);
  }

  private addInitPaymentStep() {
    this.wizardSteps.push(
      new WizardStep(
        this.wizardSteps.length,
        "Ingresá tu código",
        RoutePath.initPayment,
      ),
    );
  }

  private addInitAdminPaymentStep() {
    this.wizardSteps.push(
      new WizardStep(
        this.wizardSteps.length,
        "Verificá la información",
        RoutePath.initAdminPayment,
      ),
    );
  }

  private addReviewPaymentStep() {
    this.wizardSteps.push(
      new WizardStep(
        this.wizardSteps.length,
        "Completá tus datos",
        RoutePath.reviewPayment,
      ),
    );
  }

  private addPaymentMethodStep() {
    this.wizardSteps.push(
      new WizardStep(
        this.wizardSteps.length,
        "Método de pago",
        RoutePath.paymentMethod,
      ),
    );
  }

  private addConfirmPaymentStep() {
    this.wizardSteps.push(
      new WizardStep(
        this.wizardSteps.length,
        "Confirmá el pago",
        RoutePath.confirmPayment,
      ),
    );
  }

  private addConfirmedPaymentStep() {
    this.wizardSteps.push(
      new WizardStep(
        this.wizardSteps.length,
        "Pago confirmado",
        RoutePath.resultMessage,
      ),
    );
  }

  private addTokenizeCardSteps(cpe: string) {
    this.wizardSteps.push(
      new WizardStep(
        this.wizardSteps.length,
        "Validá tus datos",
        "tokenize-card-step-1",
      ),
    );
    this.wizardSteps.push(
      new WizardStep(
        this.wizardSteps.length,
        "Actualizá tu tarjeta",
        "tokenize-card-step-2",
      ),
    );
    this.wizardSteps.push(
      new WizardStep(
        this.wizardSteps.length,
        "Resultado",
        "tokenize-card-result",
      ),
    );
  }

  private addCvuInitPaymentSteps() {
    this.wizardSteps.push(
      new WizardStep(
        this.wizardSteps.length,
        "Ingresá tu código",
        RoutePath.cvuInitPayment,
      ),
    );
    this.wizardSteps.push(
      new WizardStep(
        this.wizardSteps.length,
        "Realiza el pago",
        RoutePath.confirmPayment,
      ),
    );
    // agrego un paso más para que muestre los que necesito en el wizzard
    this.wizardSteps.push(
      new WizardStep(
        this.wizardSteps.length,
        "Realiza el pago",
        RoutePath.resultMessage,
      ),
    );
  }

  private existExpiredPayments(payments: Payment[]): boolean {
    return payments.some((payment: Payment) => {
      const dueDate =
        payment.buildingExpense.buildingExpensePaymentStatus === 0
          ? payment.buildingExpense.dueDate1
          : payment.buildingExpense.dueDate2;
      return (
        new Date(dueDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)
      );
    });
  }

  private clearWizzardSteps() {
    this.wizardSteps = [];
  }

  isAdminPlatform() {
    return this.paymentTransactionService.isAdminPlatform;
  }

  onStepClick(step: WizardStep) {
    if (!step || step.state === null) return;
    const isTokenizeCard =
      this.wizardSteps.length > 0 &&
      this.wizardSteps[0].path?.startsWith("tokenize-card-step");
    if (isTokenizeCard) {
      const segments = this.router.url.split("/");
      const cpe = segments[2];
      if (cpe) {
        this.router.navigate([
          RoutePath.tokenizeCard,
          cpe,
          "step",
          step.stepNumber + 1,
        ]);
      }
    } else {
      const transaction = this.paymentTransactionService.getCacheTransaction();
      if (transaction && step.path) {
        this.router.navigate([step.path, transaction.id]);
      }
    }
  }
}
